import {Badge} from '@mantine/core';
import {TestDefinitionStatus} from '../types.ts';

const STATUS_CONFIG: Record<TestDefinitionStatus, { color: string, label: string }> = {
    [TestDefinitionStatus.DRAFT]: {
        color: 'gray',
        label: 'Draft'
    },
    [TestDefinitionStatus.ACTIVE]: {
        color: 'green',
        label: 'Active'
    },
    [TestDefinitionStatus.RETIRED]: {
        color: 'orange',
        label: 'Retired'
    },
};

export const TestDefinitionStatusBadge = ({status}: { status?: TestDefinitionStatus }) => {

    if (!status) {
        return <Badge color='dark'>Invalid Status</Badge>;
    }

    const config = STATUS_CONFIG[status];
    if (!config) {
        return <Badge color='dark'>{status}</Badge>;
    }

    return <Badge color={config.color}>{config.label}</Badge>;
};
